import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { AiConversation, AiConversationCreate, AiConversationFilter } from '../data/aiConversation';

export function createAiConversationService(client: AxiosInstance) {
  return createCrudService<AiConversation, AiConversationCreate, AiConversationFilter>(
    client,
    '/ai/AiConversation',
    'id',
  );
}

export type AiConversationService = CrudService<AiConversation, AiConversationCreate, AiConversationFilter>;
